import { useId } from 'react';

/**
 * HTML Query and CSS Selector compliant useID.
 * Reacts own useId contains : which cause problems.
 * @see https://github.com/facebook/react/issues/26839
 */
export function useHtmlValidId() {
  return useId().replace(/:/g, '');
}
